import angularLogo from '../images/skills/angular.png';
import reactLogo from '../images/skills/react.png';
import typescriptLogo from '../images/skills/typescript.png';
import nodeLogo from '../images/skills/node.png';
import html5Logo from '../images/skills/html5.png';
import sassLogo from '../images/skills/sass.png';
import vueLogo from '../images/skills/vue.svg';

export const skillsData = [
  {
    id: 'angular',
    label: 'Angular',
    logo: angularLogo,
    category: 'frontend',
    proficiency: 'expert',
  },
  {
    id: 'react',
    label: 'React',
    logo: reactLogo,
    category: 'frontend',
    proficiency: 'expert',
  },
  {
    id: 'typescript',
    label: 'TypeScript',
    logo: typescriptLogo,
    category: 'language',
    proficiency: 'expert',
  },
  {
    id: 'html5',
    label: 'HTML5',
    logo: html5Logo,
    category: 'frontend',
    proficiency: 'expert',
  },
  {
    id: 'sass',
    label: 'SASS',
    logo: sassLogo,
    category: 'frontend',
    proficiency: 'expert',
  },
  {
    id: 'node',
    label: 'Node.js',
    logo: nodeLogo,
    category: 'backend',
    proficiency: 'proficient',
  },
  {
    id: 'vue',
    label: 'Vue.js',
    logo: vueLogo,
    category: 'frontend',
    proficiency: 'familiar',
  },
];
